module.exports = __webpack_public_path__ + "img/heavyBlade.83d4fae6.png";